import React from 'react'

interface BackdropProps {
  children: React.ReactNode
  onClose?: () => void
  style?: React.CSSProperties
}

export default function Backdrop({ children, onClose, style = {} }: BackdropProps) {
  return (
    <div
      onClick={(e) => {
        if (e.target === e.currentTarget && onClose) onClose()
      }}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,30,56,0.52)',
        backdropFilter: 'blur(6px)',
        zIndex: 500,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        animation: 'bIn .3s ease both',
        ...style,
      }}
    >
      {children}
    </div>
  )
}
